import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkNull } from "../../../helpers";
import { actionTypes } from "../../../Redux";
import {
  backButtonHandler,
  downloadPayeeTemplate,
  getSetupDetails,
  removePayee,
  saveSetupWizardForm,
  uploadPayee,
} from "../../../Redux/actions";
import BtmButtons from "../../Components/BtmButtons";
import ExcelContainer from "../../Components/ExcelContainer";
import SWInterface from "../../Components/Layout/SWInterface";

const SetupWizardSeven = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    account,
    default_accounts,
    fgs,
    countries,
    states,
    stateFilter,
    cterms,
    yesNoSource,
  } = useSelector((state) => state.authReducer.setup_wizard_details);
  const { user } = useSelector((state) => state.authReducer.user_details);
  const upload_payee = useSelector((state) => state.authReducer.upload_payee);
  const defaultPayeeData = [
    [
      "new",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
  ];

  const onFileChangeEvent = (event) => {
    if (event?.target?.files[0]) {
      const formData = new FormData();
      formData.append(
        "payee_file",
        event.target.files[0],
        event.target.files[0]?.name
      );
      dispatch(uploadPayee(formData));
      event.target.value = null;
    }
  };

  useEffect(() => {
    if (user?.merchant?.parent_merchant_id > 0) {
      dispatch(backButtonHandler());
    } else {
      dispatch(getSetupDetails(6));
    }
  }, []);

  const submitNextHandler = (isLogout = false) => {
    dispatch(
      saveSetupWizardForm("six", {
        payee_sheet_data: upload_payee?.finaldata ?? "",
      })
    );
  };

  return (
    <SWInterface step={6}>
      <div className="steps-content">
        <div className="steps-div_outer">
          <div class="staff_upload" id="step4">
            <h4 class="event-alert mb-0"> Payee Upload </h4>
            <p>
              To expedite your onboarding process onto GoGMGo, please take this
              time to bulk upload your payee information (including suppliers,
              landlords, utility companies, etc.). Start by downloading the
              below .xlsx format template and follow the instructions.
            </p>
            <div class="row-fluid">
              <div class="input-group my-4">
                <a
                  onClick={() => dispatch(downloadPayeeTemplate())}
                  class="btn_btnblue btn download"
                >
                  <span class="i-icon"> </span> Download Template{" "}
                </a>{" "}
              </div>
            </div>
            <div class="row-fluid pt-0">
              <div class="span12">
                <div class="dropdown-table accordion-wrap">
                  <div id="accordion" class="inv-accordion">
                    <h3 class="event-alert rowNum_1 isOpen opened-h2">
                      Payee Bulk Upload
                    </h3>
                    <div class="row_buttons">
                      <form
                        method="post"
                        id="form_payee_upload"
                        enctype="multipart/form-data"
                        accept-charset="utf-8"
                      >
                        <div class="input-group shift_action ">
                          <input
                            type="file"
                            name="payee_file"
                            id="payee_file"
                            class="inputfile inputfile-2"
                            data-multiple-caption="{count} files selected"
                            onChange={onFileChangeEvent}
                          />
                          <label
                            class="btn btn_btnblue upload-icon"
                            for="payee_file"
                          >
                            {" "}
                            <span class="i-icon"> </span>{" "}
                            <span>Upload Payee</span>
                          </label>
                          <button
                            class="btn cancel"
                            type="button"
                            onClick={() =>
                              checkNull(upload_payee?.finaloutput, false)
                                ? dispatch(removePayee())
                                : null
                            }
                          >
                            Remove Payee
                          </button>
                        </div>
                      </form>{" "}
                    </div>
                    <div divnum="1" class="accordionDiv opened-div2">
                      <div class="inner-space table-responsive">
                        <div id="payeetranst">
                          <ExcelContainer
                            data={upload_payee?.finaloutput ?? defaultPayeeData}
                            pagination={100}
                            dimensions={[27, 10]}
                            columns={[
                              {
                                type: "autocomplete",
                                title: "Default Payment Account",
                                width: "170",
                                source: default_accounts,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "Expense Type",
                                width: "150",
                                source: fgs,
                                autocomplete: true,
                              },
                              {
                                type: "text",
                                title: "Payee Name",
                                width: "200",
                              },
                              {
                                type: "text",
                                title: "Expense Account",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Contact Name",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Contct Number #1",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Contact Number #2",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Email",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Address Line #1",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Address Line #2",
                                width: "150",
                              },
                              {
                                type: "autocomplete",
                                title: "Country",
                                width: "100",
                                source: countries,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "State",
                                width: "100",
                                source: states,
                                autocomplete: true,
                                filter: stateFilter,
                              },
                              {
                                type: "text",
                                title: "City",
                                width: "100",
                              },
                              {
                                type: "text",
                                title: "Zip Code",
                                width: "100",
                              },
                              {
                                type: "text",
                                title: "Address Line #1",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Address Line #2",
                                width: "150",
                              },
                              {
                                type: "autocomplete",
                                title: "Country",
                                width: "100",
                                source: countries,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "State",
                                width: "100",
                                source: states,
                                autocomplete: true,
                                filter: stateFilter,
                              },
                              {
                                type: "text",
                                title: "City",
                                width: "100",
                              },
                              {
                                type: "text",
                                title: "Zip Code",
                                width: "100",
                              },
                              {
                                type: "autocomplete",
                                title: "Credit Terms",
                                width: "100",
                                source: cterms,
                                autocomplete: true,
                              },
                              {
                                type: "number",
                                title: "Interest Rate",
                                width: "100",
                              },
                              {
                                type: "number",
                                title: "Tax Rate",
                                width: "100",
                                // mask: '#.#',
                                decimal: ",",
                              },
                              {
                                type: "text",
                                title: "Bank Name",
                                width: "150",
                                // mask: '#.#',
                                decimal: ",",
                              },
                              {
                                type: "text",
                                title: "Account",
                                width: "100",
                              },
                              {
                                type: "text",
                                title: "Routing",
                                width: "100",
                              },
                              {
                                type: "autocomplete",
                                title: "Primary",
                                width: "100",
                                source: yesNoSource,
                              },
                              {
                                type: "hidden",
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BtmButtons submitHandler={submitNextHandler} />
          </div>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardSeven;
